import { createStore, StateMachineProvider } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Outlet, useLocation } from 'react-router-dom';
import { StepNav } from '../../../Components/Reuseables';
import FrontFooter from '../../../Pages/front/components/FrontFooter';
import FrontNav from '../../../Pages/front/components/FrontNav';

createStore({});

const STEPS = ['Step1', 'Step2', 'Step3'];
export const TraineeSignUp = () => {
  const location = useLocation();
  let pathname = location.pathname;
  const [step, setStep] = useState(pathname.split('/')[3]);
  useEffect(() => {
    setStep(pathname.split('/')[3]);
  }, [pathname]);

  return (
    <div className="front">
      <FrontNav />
      {/* trainee Registration form begins here */}
      <section className="pt-4 pt-md-4 bg-gray-200">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex justify-content-between align-items-center">
                    <h1 className="mb-0  text-primary">
                      <FormattedMessage id="participant_registration_form" />
                    </h1>
                    <StepNav>
                      {STEPS.map((title, index, { length }) => {
                        let stepName;
                        switch (step) {
                          case undefined:
                            stepName = STEPS[0];
                            break;
                          default:
                            stepName = STEPS[parseInt(step)];
                        }
                        let _class = 'bg-primary text-light';
                        if (index == 0) {
                          _class = `${_class} first-step`;
                        }
                        if (index + 1 === length) {
                          _class = `${_class} last-step`;
                        }
                        return (
                          <div key={index} className={title === stepName ? _class : ''}>
                            <span>
                              <small>{title}</small>
                            </span>
                          </div>
                        );
                      })}
                    </StepNav>
                  </div>
                </div>
                <div className="card-body pt-2 ">
                  <StateMachineProvider>
                    <Outlet />
                  </StateMachineProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="position-relative mt-n15">
        <div className="shape shape-bottom shape-fluid-x bg-text-dark">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <section className="pt-15 bg-dark" />
      <section className="py-8 py-md-11 bg-dark" />
      <div className="position-relative">
        <div className="shape shape-bottom shape-fluid-x text-gray-200">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>

      <FrontFooter />
    </div>
  );
};
